/**
 * Register Your Interest — builds and submits a standalone Shopify customer
 * form (so it works even when the markup sits inside the theme's
 * <form action="/cart/add">, where nested forms aren't allowed).
 *
 * Flow: validate email -> build a detached <form method="post"
 * action="/contact#contact_form"> with Shopify's customer fields ->
 * wire it through Shopify's CAPTCHA (window.Shopify.captcha.protect) ->
 * submit. Shopify then creates/finds the Customer, adds the tag, and
 * redirects back to the product page with ?customer_posted=true.
 */
(function () {
  var STORAGE_KEY = 'register-interest-pending';

  // Shopify doesn't reliably append ?customer_posted=true when return_to is
  // set, so we also leave a short-lived marker in sessionStorage before
  // submitting and look for it when the redirect lands back on the page.
  function returningFromSubmit() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') return true;
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      window.sessionStorage.removeItem(STORAGE_KEY);
      var pending = JSON.parse(raw);
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      var viaHistory = nav && nav.type === 'back_forward';
      return !viaHistory && pending.path === window.location.pathname && Date.now() - pending.time < 120000;
    } catch (e) {
      return false;
    }
  }

  function showSuccessIfReturning() {
    if (!returningFromSubmit()) return;
    document.querySelectorAll('[data-register-interest]').forEach(function (root) {
      var fields = root.querySelector('[data-ri-fields]');
      var success = root.querySelector('[data-ri-success]');
      if (fields) fields.hidden = true;
      if (success) success.hidden = false;
    });
  }

  function addHidden(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function submit(root) {
    var emailInput = root.querySelector('[data-ri-email]');
    var error = root.querySelector('[data-ri-error]');
    var button = root.querySelector('[data-ri-submit]');
    var email = emailInput ? emailInput.value.trim() : '';

    if (!emailInput || !email || !emailInput.checkValidity()) {
      if (error) error.hidden = false;
      if (emailInput) emailInput.focus();
      return;
    }
    if (error) error.hidden = true;
    if (button) button.disabled = true;

    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/contact#contact_form';
    form.acceptCharset = 'UTF-8';
    form.style.display = 'none';
    addHidden(form, 'form_type', 'customer');
    addHidden(form, 'utf8', '✓');
    addHidden(form, 'return_to', root.getAttribute('data-return-to') || window.location.pathname);
    addHidden(form, 'contact[tags]', root.getAttribute('data-tag') || '');
    addHidden(form, 'contact[email]', email);
    document.body.appendChild(form);

    var go = function () {
      try {
        window.sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ path: window.location.pathname, time: Date.now() })
        );
      } catch (e) { /* storage unavailable: success message simply won't show */ }
      form.submit();
    };
    var captcha = window.Shopify && window.Shopify.captcha;
    if (captcha && typeof captcha.protect === 'function') {
      captcha.protect(form, go);
    } else {
      go();
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ri-submit]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    submit(button.closest('[data-register-interest]'));
  });

  // Enter inside the email field would otherwise submit the surrounding
  // add-to-cart form.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-ri-email]');
    if (!input) return;
    event.preventDefault();
    event.stopPropagation();
    submit(input.closest('[data-register-interest]'));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showSuccessIfReturning);
  } else {
    showSuccessIfReturning();
  }
})();
